import { lazy } from "react";
const FullLayout = lazy(() => import("components/layouts/FullLayout"));
const BlankLayout = lazy(() => import("components/layouts/BlankLayout.js"));

const indexRoutes = [
  { path: '/', name: 'Home', component: FullLayout },
  { path: '/authentication', name: 'Authentication', component: BlankLayout },
];

export default indexRoutes;
